import { cn as e } from "../shared/utils.js";
import { Radio as t } from "./primitive/index.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/radio/radio-button.tsx
function i({ className: i, indicatorProps: a, label: o, labelProps: s, rootProps: c, value: l }) {
	let u = !!o;
	return /* @__PURE__ */ r("label", {
		className: e("text-text-primary inline-flex items-start gap-2 text-base font-normal", c?.disabled ? "text-text-disabled cursor-not-allowed" : "cursor-pointer", i),
		children: [/* @__PURE__ */ n(t.Root, {
			...c,
			className: c?.className,
			value: l,
			children: /* @__PURE__ */ n(t.Indicator, {
				...a,
				className: a?.className
			})
		}), u && /* @__PURE__ */ n("span", {
			...s,
			className: e("leading-5", s?.className),
			children: o
		})]
	});
}
//#endregion
export { i as RadioButton };
